'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Promise = window.Promise;

window.hubspot.require(['Q'], function (Q) {
  exports.Promise = Promise = Q.Promise;
});

exports.Promise = Promise;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.161/js/helpers/promise.js
// module id = 24
// module chunks = 0